// extracted by mini-css-extract-plugin
module.exports = {"errorMsg":"BadRequestMessage_errorMsg__2Escr","DescFont":"BadRequestMessage_DescFont__CsSZc","backLink":"BadRequestMessage_backLink__2Zh2B"};